ko.bindingHandlers.fileupload = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        var options = valueAccessor();
        var fu = $(element).fileupload(options);
        var opt = fu.fileupload("option");

        if (options.files) {
            fu.fileupload("add", { files: ko.isObservable(options.files) ? options.files() : options.files })
        }

        if (options.fileuploaddone) {
            fu.on("fileuploaddone", options.fileuploaddone);
        }

        fu.on("fileuploadadd",
            $.proxy(function (options, e, data) {

                if (e.delegatedEvent == null) {
                    return
                }

                if (data.files.length > 0 && opt.singleFileUploads) {
                    opt.filesContainer.empty();
                }

                if (options.files && ko.isObservable(options.files)) {
                    options.files(data.files);
                }

                if (options.onAdd) {
                    options.onAdd(data, e);
                }
            }, fu, options));

        fu.on("fileuploadfail",
            $.proxy(function (options, e, data) {

                if (data.files.length > 0 && opt.singleFileUploads) {
                    opt.filesContainer.empty();
                }

                if (options.files && ko.isObservable(options.files)) {
                    options.files(data.files);
                }

                if (options.onFail) {
                    options.onFail(data, e);
                }
            }, fu, options));

        
    }
}